import { render, staticRenderFns } from "./PrivateElement.vue?vue&type=template&id=24d03161&scoped=true"
import script from "./PrivateElement.vue?vue&type=script&lang=js"
export * from "./PrivateElement.vue?vue&type=script&lang=js"
import style0 from "./PrivateElement.vue?vue&type=style&index=0&id=24d03161&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d03161",
  null
  
)

export default component.exports